import fetch from 'isomorphic-fetch';

// variable url del servidor
const BASEURL = 'https://stage.crashmap.netmidas.com/api/v1/';
const BASEURL_SLIDER = 'https://a.mapillary.com/v3/images/?client_id=d1RmVmxsUVl2SkNKRzBzUXNtUXlqZzphYTgwZjkzMjYwOThiMTE5&per_page=5&page=0&';
const SLIDER_GOOGLE = 'https://maps.googleapis.com/maps/api/streetview?';
const AUTH_TOKEN = 'e025272d83fcff4337aea403fea72fff46325793';

let vizInfo = {};
const { REACT_APP_LOCATION, REACT_APP_GOOGLE_TOKEN } = process.env;

const API = {
  app: {
    async getGeneralInfo() {
      // Get the data related with the viz that is been compile

      const response = import('../assets/data/vizInfo.json').then(data => data);
      const data = await response;
      const vizFinded = await data[REACT_APP_LOCATION];

      // ----- Set a variable to allow the other methods in this file to access to this data
      vizInfo = vizFinded;

      return vizFinded;
    },
    async getClienInfo() {
      const { REACT_APP_CLIENT } = process.env;
      // Get the data related with the viz that is been compile

      const response = import('../assets/data/clientInfo.json').then(data => data);
      const data = await response;
      const clientData = await data[REACT_APP_CLIENT];

      return clientData;
    },
  },
  map: {
    async getFilteredData(params) {
      const { dataBounds, locationEndPoint } = vizInfo;
      // Get the incidents filtered

      const initLat = dataBounds.initLat;
      const initLon = dataBounds.initLon;
      const endtLat = dataBounds.endtLat;
      const endtLon = dataBounds.endtLon;
      const finalParams = this.getFinalParams(params);
      const finalBounds = `init_latitude=${initLon}&init_longitude=${initLat}&end_latitude=${endtLon}&end_longitude=${endtLat}`;
      const response = await fetch(`${BASEURL}${locationEndPoint}/incidents/?${finalBounds}&${finalParams}&auth_token=${AUTH_TOKEN}`);
      const data = await response.json();
      const dataGroup = [data, `?${finalParams}`];
      return dataGroup;
    },
    async getCategoryData(category) {
      const { locationEndPoint } = vizInfo;
      // Get incidents categories

      const response = await fetch(`${BASEURL}${locationEndPoint}/incidents/${category}?auth_token=${AUTH_TOKEN}`);
      const data = await response.json();
      return data;
    },
    getFinalParams(params) {
      let finalParams = null;
      if (typeof params === 'object') {
        finalParams = params.join('&');
      } else {
        finalParams = params;
      }
      return finalParams;
    },
  },
  popUp: {
    async getIncidentData(idIncident) {
      const { locationEndPoint } = vizInfo;
      // Get incident data

      const response = await fetch(`${BASEURL}${locationEndPoint}/incidents/${idIncident}/?auth_token=${AUTH_TOKEN}`);
      const data = await response.json();
      return data;
    },
    async getSliderData(location) {
      // Get slider data

      const initLat = location[0];
      const initLon = location[1];
      let data = null;
      if (REACT_APP_LOCATION === 'corpus_christi') {
        const response = await fetch(`${SLIDER_GOOGLE}location=${initLat},${initLon}&size=600x300&fov=120&key=${REACT_APP_GOOGLE_TOKEN}`);
        data = await response.url;
      } else {
        const response = await fetch(`${BASEURL_SLIDER}closeto=${initLon},${initLat}&radius=3000`);
        data = await response.json();
      }

      return data;
    },
  },
};
export default API;
